export default "__VITE_ASSET__Cam3fSVW__"